import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[lang]/places/restaurants/page.client.tsx");
